import { GL_DEPT_INIT_SUCCESS, GL_DEPT_INIT_FAIL, GL_DEPT_INIT_LOADING } from '@/store/types'
import http from '@/utils/ajax'
import { extractMenu, extractMessages } from '@/utils/extract'

const state = {
  init: 0,
  initErr: [],
  menu: {}
}

const getters = {}

const mutations = {
  [GL_DEPT_INIT_LOADING](state) {
    state.init = 0
    state.menu = {}
    state.initErr = []
  },
  [GL_DEPT_INIT_SUCCESS](state, data) {
    state.init = 1
    state.menu = data.menu
    state.initErr = []
  },
  [GL_DEPT_INIT_FAIL](state, err) {
    state.init = 2
    state.menu = {}
    state.initErr = err
  }
}

const actions = {
  async glDeptManagementInit({ commit, rootState }) {
    const apiUrl = rootState.app.menu.glDepartmentManagement
    commit(GL_DEPT_INIT_LOADING)
    if (apiUrl) {
      try {
        const result = await http.get(apiUrl)
        const menu = extractMenu(result.data._links)
        const commitResult = {
          menu
        }
        commit(GL_DEPT_INIT_SUCCESS, commitResult)
      } catch (error) {
        commit(GL_DEPT_INIT_FAIL, extractMessages(error))
      }
    }
  }
}

export default {
  state,
  getters,
  mutations,
  actions
}
